window.Sq = window.Sq || {};
Sq.Shop = Sq.Shop || {};
$(() => Sq.Shop.ReturnItems.init());

Sq.Shop.ReturnItems = {
  init() {
    if ($('#return-items-form').length === 0) {
      return;
    }

    this.getHtml();
    this.getData();
    this.bindEvents();
    this.updateForm();
  },

  getHtml() {
    this.$form = $('#return-items-form');
    this.$items = $('.line-item:not(.disabled)');
    this.$count = $('.return-items-count');
    this.$subtotal = $('.return-items-subtotal');
  },

  getData() {
    this.locale = Sq.Environment.locale;
  },

  bindEvents() {
    this.$form.on('change', '.line-item:not(.disabled)', (e) =>
      this.onLineItemChange(e)
    );
    this.$form.on('click', '.line-item:not(.disabled)', (e) =>
      this.onLineItemClick(e)
    );
  },

  onLineItemChange() {
    this.updateForm();
  },

  onLineItemClick(e) {
    const clickedInput = $(e.target).closest('input').length > 0;
    const clickedLabel = $(e.target).closest('label').length > 0;
    const clickedSelect = $(e.target).closest('select').length > 0;
    if (!clickedInput && !clickedLabel && !clickedSelect) {
      const $item = $(e.currentTarget);
      const $checkbox = $item.find('input[name="selected[]"]');
      const isChecked = $checkbox.prop('checked');
      $checkbox.prop('checked', !isChecked).trigger('change');
    }
  },

  updateForm() {
    let count = 0;
    let subtotal = 0;
    let currency = '';

    this.$items.each((i, el) => {
      const $li = $(el);
      const $itemTotal = $li.find('.line-item-total');
      const $checkbox = $li.find('[name="selected[]"]');
      const $quantity = $li.find('[name="line_items[][quantity]"]');

      const quantity = Number.parseInt($quantity.val(), 10);
      const selected = $checkbox.prop('checked');
      currency = $li.find('[name="currency"]').val();
      const unitPrice = Number.parseFloat(
        $li.find('[name="unit-price"]').val()
      );

      if (selected) {
        const itemTotal = quantity * unitPrice;
        count += quantity;
        subtotal += itemTotal;
        $itemTotal.text(this.formatCurrency(itemTotal, currency));
      } else {
        $itemTotal.text('');
      }
    });

    this.$count.text(count);
    this.$subtotal.text(this.formatCurrency(subtotal, currency));
  },

  formatCurrency(amount, currency) {
    return amount.toLocaleString(this.locale, {
      style: 'currency',
      currency,
    });
  },
};
